import React, { useState } from "react";
import "./NewMatch.css";
// import "../App.css";
import * as FirestoreService from "../../utils/firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function NewMatch() {
  const notify = (text) => toast(`${text}`);
  function generateCode() {
    let code = Math.random().toString().substr(2, 6);
    return code;
  }

  function addNewMatch(e) {
    e.preventDefault();
    setPlayer1("");
    setPlayer2("");
    setTime("");
    setCourt(1);
    let code = generateCode();
    FirestoreService.isCodeUnique(code).then((e) => {
      // CONVERT TIME INPUT TO MINUTES
      let hoursAndMinutes = time.split(":");
      hoursAndMinutes[0] = parseInt(hoursAndMinutes[0]);
      hoursAndMinutes[1] = parseInt(hoursAndMinutes[1]);
      let minutes = hoursAndMinutes[0] * 60 + hoursAndMinutes[1];
      let isCodeUnique = e.empty;
      if (isCodeUnique) {
        FirestoreService.addMatch({
          code: code,
          court: court,
          player1: player1,
          player2: player2,
          time: minutes,
          scoreplayer1: 0,
          scoreplayer2: 0,
        });
        notify("Dodano mecz");
      }
    });
  }

  const [player1, setPlayer1] = useState("");
  const [player2, setPlayer2] = useState("");
  const [time, setTime] = useState("");
  const [court, setCourt] = useState(1);

  return (
    <div className="container">
      <ToastContainer
        autoClose={2000}
        hideProgressBar={true}
        pauseOnHover={false}
        style={{ color: "#343434" }}
      />
      <h1>Nowy mecz</h1>

      <form className="match-form" onSubmit={addNewMatch}>
        <div>
          <input
            value={player1}
            onChange={(e) => setPlayer1(e.target.value)}
            className="match-form-input"
            type="text"
            name="player1"
            aria-describedby="player1"
            placeholder="Gracz 1"
            required
          />
        </div>
        <div>
          <input
            value={player2}
            onChange={(e) => setPlayer2(e.target.value)}
            className="match-form-input"
            type="text"
            name="player2"
            aria-describedby="player2"
            placeholder="Gracz 2"
            required
          />
        </div>
        <div>
          <select
            value={court}
            className="match-form-input"
            name="court"
            onChange={(e) => setCourt(e.target.value)}
          >
            {[1, 2, 3, 4, 5, 6, 7].map((court) => (
              <option value={court}>Kort {court}</option>
            ))}
          </select>
          <input
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="match-form-input"
            type="time"
            name=""
            id=""
            required
          />
        </div>
        <button type="submit" className="match-form-btn">
          Dodaj
        </button>
      </form>
    </div>
  );
}
